import { changeLinkPermission, UNDEFINED_EXPIRATION_DATE } from 'owa-fileprovider-link-services';
import { onLinkHasChanged, updateSharingLinkPermission } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import CreateAttachmentSharingLinkResponse from 'owa-service/lib/contract/CreateAttachmentSharingLinkResponse';
import * as trace from 'owa-trace';
import { orchestrator } from 'satcheljs';
import { createOrUpdateSharingLink, updateSharingLinkUrl } from '../actions/internalActions';
import { createSharingLink } from '../services/createSharingLink';

orchestrator(createOrUpdateSharingLink, async actionMessage => {
    let newLinkUrl: string = actionMessage.sharingUrl;
    let expirationDate: string = null;
    if (newLinkUrl === null) {
        switch (actionMessage.providerType) {
            case AttachmentDataProviderType.OneDrivePro:
                const response: CreateAttachmentSharingLinkResponse = await createSharingLink(
                    actionMessage.canonicalUrl,
                    actionMessage.newPermissionLevel
                );
                newLinkUrl = response.Link;
                expirationDate = response.ExpirationDate;
                break;
            case AttachmentDataProviderType.OneDriveConsumer:
                const sharingLinkFromFileProviderResult = await changeLinkPermission(
                    AttachmentDataProviderType.OneDriveConsumer,
                    actionMessage.currentUrl,
                    actionMessage.newPermissionLevel
                );
                if (!!sharingLinkFromFileProviderResult) {
                    newLinkUrl = sharingLinkFromFileProviderResult.link.webUrl;
                    if (
                        sharingLinkFromFileProviderResult.expirationDateTime !==
                        UNDEFINED_EXPIRATION_DATE
                    ) {
                        expirationDate = sharingLinkFromFileProviderResult.expirationDateTime;
                    }
                }
                break;
            case AttachmentDataProviderType.GDrive:
                await changeLinkPermission(
                    AttachmentDataProviderType.GDrive,
                    actionMessage.currentUrl,
                    actionMessage.newPermissionLevel
                );
                break;
            default:
                trace.errorThatWillCauseAlert('Data provider is not supported');
        }
    }

    /*
        1. update link url, expiration date and etc for ODB and ODC;
        2. link permission control is only enabled for ODB, ODC and GDrive, so other links won't trigger this orchestrator;
        3. GDrive link url won't change when permission gets changed, so no need to update the link url;
    */
    if (actionMessage.providerType != AttachmentDataProviderType.GDrive) {
        updateSharingLinkUrl(
            actionMessage.linkId,
            newLinkUrl,
            actionMessage.currentUrl,
            expirationDate
        );
    }

    updateSharingLinkPermission(actionMessage.linkId, actionMessage.newPermissionLevel);

    // check recipients' permission based on the new permission level
    onLinkHasChanged(
        actionMessage.linkId,
        actionMessage.recipientInfos,
        actionMessage.composeId,
        actionMessage.isCalendar
    );
});
